import type { ReactNode } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { PostHogPageView } from './PostHogPageView'
import { Sentry } from './sentry'

export function AppTree({ children }: { children: ReactNode }) {
  return (
    <BrowserRouter>
      <PostHogPageView />
      <Sentry.ErrorBoundary
        fallback={
          <div style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif' }}>
            <h1>Something went wrong</h1>
            <p>Please refresh the page and try again.</p>
          </div>
        }
      >
        {children}
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  )
}
